import {Model} from './Model';

export class OpenPeriod extends Model {
  public start: string = '';
  public end: string = '';
  public sameDay: boolean = true;
  public sameMonth: boolean = true;

  constructor(openingTime, sameDay: boolean = true, sameMonth: boolean = true) {
    super(openingTime);
    this.start = openingTime.start;
    this.end = openingTime.end;
    this.sameDay = sameDay;
    this.sameMonth = sameMonth;
  }

  toString(): string {
    return '';
  }
}
